export default __webpack_public_path__ + "static/media/lib-1.c755c353.png";